import IClerk, { IClerkResponse } from "@/types/clerk";
const mutations = {
  SET_CLERK: (state: IClerk, payload: IClerkResponse): void => {
    state.clerk = payload;
  },
  SET_CLERK_JWT: (state: IClerk, payload: string): void => {
    state.jwt = payload;
  },
};
export default mutations;
